import React from 'react';

// Helper function to get logo URL for tech stack - using colored devicons
const getTechLogo = (techName) => {
  const logoMap = {
    'React': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg',
    'TypeScript': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg',
    'Redux': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg',
    'Node.js': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg',
    'Module Federation': 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/webpack/webpack-original.svg'
  };
  
  if (techName.includes('React')) return logoMap['React'];
  if (techName.includes('TypeScript')) return logoMap['TypeScript'];
  if (techName.includes('Redux')) return logoMap['Redux'];
  if (techName.includes('Node')) return logoMap['Node.js'];
  if (techName.includes('Module') || techName.includes('Federation')) return logoMap['Module Federation'];
  
  return logoMap[techName] || null;
};

const CaseStudies = () => {
  const caseStudies = [
    {
      id: 1,
      title: 'Walgreens Workflow UI Redesign',
      problem: 'Legacy UI slow & confusing',
      solution: 'Built modular React + TS workflows',
      result: '60% faster task completion, fewer user errors',
      tech: ['React', 'TypeScript', 'Redux'],
    },
    {
      id: 2,
      title: 'Maersk Micro-Frontend Architecture',
      problem: 'Multiple apps causing deployment delays',
      solution: 'Built secure micro-frontend routing system',
      result: '45% faster deployments',
      tech: ['React', 'Module Federation', 'Node.js'],
    }
  ];

  return (
    <section id="case-studies" className="case-studies-section">
      <div className="case-studies-container">
        <div className="section-header">
          <h2 className="section-title">Case Studies</h2>
          <p className="section-subtitle">
            Real-world solutions that delivered measurable impact
          </p>
        </div>

        <div className="case-studies-grid">
          {caseStudies.map((study) => (
            <div key={study.id} className="case-study-card">
              <h3 className="case-study-title">{study.title}</h3>
              
              <div className="case-study-content">
                <div className="case-study-item">
                  <span className="case-label">Problem:</span>
                  <span className="case-text">{study.problem}</span>
                </div>
                
                <div className="case-study-item">
                  <span className="case-label">Solution:</span>
                  <span className="case-text">{study.solution}</span>
                </div>
                
                <div className="case-study-item">
                  <span className="case-label">Result:</span>
                  <span className="case-text">{study.result}</span>
                </div>
                
                <div className="case-study-tech">
                  <span className="tech-label">Tech:</span>
                  {study.tech.map((t, idx) => {
                    const logoUrl = getTechLogo(t);
                    return (
                      <span key={idx} className="tech-tag">
                        {logoUrl && (
                          <img src={logoUrl} alt={t} className="tech-tag-logo" />
                        )}
                        {t}
                      </span>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;

